export class GoogleHealthConnect {
  userId: number;

  constructor(userId: number) {
    this.userId = userId;
  }

  async authorize() {
    console.log('Google Health Connect authorize unavailable');
    return false;
  }

  openHealthConnectSettings() {
    console.log('Google Health Connect openHealthConnectSettings unavailable');
    return;
  }

  async getGrantedPermissions() {
    console.log('Google Health Connect getGrantedPermissions unavailable');
    return [];
  }

  async checkPermissions() {
    console.log('Google Health Connect checkPermissions unavailable');
    return [];
  }

  async getDataToSynchronize(progress: (message: string) => void) {
    console.log('Google Health Connect no data to sync');
    return [];
  }

  async getSleepData(startDate: Date) {
    console.log('REMOVE');
    return [];
  }
}
